import { Component, OnInit } from '@angular/core';

@Component({
  selector: 's18-admin-event-context-menu',
  templateUrl: './admin-event-context-menu.component.html',
  styleUrls: ['./admin-event-context-menu.component.scss']
})
export class AdminEventContextMenuComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
